
import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { catalogItems, featuredContent, categories, genres } from '../../mocks/content';

const CatalogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [selectedGenre, setSelectedGenre] = useState('Todos los géneros');
  const allContent = [...featuredContent, ...catalogItems];

  const filteredContent = allContent.filter((item) => {
    const categoryMatch = selectedCategory === 'Todos' || item.type === selectedCategory;
    const genreMatch = selectedGenre === 'Todos los géneros' || item.genre === selectedGenre;
    return categoryMatch && genreMatch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-16 px-6">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-purple-900/20 via-transparent to-transparent"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto text-center space-y-6">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-6xl lg:text-7xl font-black text-white"
          >
            Catálogo <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-cyan-500">Completo</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl text-gray-300 max-w-3xl mx-auto"
          >
            Explora nuestra colección completa de películas, series, anime, novelas y libros
          </motion.p>
        </div>
      </section>

      {/* Filters */}
      <section className="px-6 pb-12">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Category Filter */}
          <div>
            <h3 className="text-white text-sm font-bold mb-3 uppercase tracking-wider">Tipo de Contenido</h3>
            <div className="flex flex-wrap gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white shadow-lg shadow-pink-500/50'
                      : 'bg-white/10 text-white/80 hover:bg-white/20 border border-white/20'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Genre Filter */}
          <div>
            <h3 className="text-white text-sm font-bold mb-3 uppercase tracking-wider">Género</h3>
            <div className="flex flex-wrap gap-3">
              {genres.map((genre) => (
                <button
                  key={genre}
                  onClick={() => setSelectedGenre(genre)}
                  className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    selectedGenre === genre
                      ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white shadow-lg shadow-cyan-500/50'
                      : 'bg-white/10 text-white/80 hover:bg-white/20 border border-white/20'
                  }`}
                >
                  {genre}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Content Grid */}
      <section className="px-6 pb-24">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8 flex items-center justify-between">
            <p className="text-gray-400">
              Mostrando <span className="text-white font-bold">{filteredContent.length}</span> resultados
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {filteredContent.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                className="group relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="w-full aspect-[2/3]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 space-y-2">
                    <h3 className="text-white font-bold text-lg">{item.title}</h3>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-300">{item.year}</span>
                      <span className="text-gray-300">{item.genre}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-${i < Math.floor(item.rating) ? 'fill' : 'line'} text-yellow-400 text-sm`}
                        ></i>
                      ))}
                      <span className="text-white text-sm ml-2">{item.rating}</span>
                    </div>
                    <div className="pt-2">
                      <span className="inline-block px-3 py-1 bg-pink-500 text-white text-xs font-bold rounded-full">
                        {item.type}
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CatalogPage;
